/* Tikadeau — menu mobile sur-mesure (snippet mobile-menu.liquid).
   Délégation d'événements sur document : survit à la réhydratation
   du bloc header__drawer (data-hydration-key) par Horizon. */
(function () {
  var OPEN = 'is-open';

  function menu() {
    return document.querySelector('.tk-mm');
  }

  /* Apps tierces (chat, etc.) qui se placent au premier plan avec un
     z-index très élevé — masquées tant que le menu est ouvert pour
     qu'elles ne recouvrent pas / ne grisent pas le menu. */
  function overlayApps() {
    return document.querySelectorAll('#rawa-container, [id*="chat-widget"], #shopify-chat');
  }

  function openMenu() {
    var m = menu();
    if (!m) return;
    m.classList.add(OPEN);
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    overlayApps().forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function closeMenu() {
    var m = menu();
    if (!m) return;
    m.classList.remove(OPEN);
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    overlayApps().forEach(function (el) {
      el.style.removeProperty('display');
    });
  }

  /* Le burger du header ouvre CE menu. Capture + preventDefault +
     stopImmediatePropagation neutralisent le drawer Horizon natif
     (qui reste le fallback si ce fichier ne se charge pas). */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      var burger = e.target.closest('summary.header__icon--summary');
      if (!burger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openMenu();
    },
    true
  );

  /* Fermeture + accordéon sous-menus (délégué, phase bubble). */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('.tk-mm [data-tk-close]')) {
      closeMenu();
      return;
    }

    var toggle = e.target.closest('.tk-mm [data-tk-submenu]');
    if (toggle) {
      e.preventDefault();
      var item = toggle.closest('.tk-mm__item');
      if (!item) return;
      var sublist = item.querySelector('.tk-mm__sublist');
      var willOpen = !item.classList.contains(OPEN);
      item.classList.toggle(OPEN, willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (sublist) sublist.hidden = !willOpen;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();
